import md5 from 'js-md5';
import _ from 'lodash';
import {
  UserType,
  UserSubscriptionType,
  PlanNames,
} from '../../../app/modules/core';

export default angular
  .module('doxy.common.services.currentUserHelper', [])
  .factory('currentUserHelper', function ($ngRedux) {
    return {
      user: null,
      institution: null,
      getDisplayName() {
        return this.user.getDisplayName();
      },

      /**
       * @param {String} planName
       * @returns {*}
       */
      getPlanFromStoreById(planName) {
        const plans = $ngRedux.getState().system.plans;

        if (!plans.length) return null;

        return _.find(plans, { id: planName });
      },

      getActivePurchase() {
        const purchases = $ngRedux.getState().system.purchases;
        return purchases.find((purchase) => purchase.isActive === true);
      },

      extractTrialEndDate(user = this.user, purchases = []) {
        const trialPurchase = _.find(
          purchases,
          (p) => Boolean(p.trialEnd) && Boolean(p.isActive)
        );
        const purchaseTrialEndDate = trialPurchase?.trialEnd;
        return user.trialEndDate || purchaseTrialEndDate || null;
      },

      getProfilePictureUrl(user = this.user, size = 64) {
        if (_.isNumber(user)) {
          size = user;
          user = this.user;
        }

        if (!user.useProfilePicture) return;

        const defaultImage = '/assets/icons/legacy/avatar.svg';
        let url = '';

        switch (user.profilePictureProvider) {
          case 'doxymeProfilePicture':
          case 'LinkedIn':
            url = user.userProfilePictureUrl
              ? user.userProfilePictureUrl
              : defaultImage;
            break;
          case 'gravatar':
            user.gravatarId =
              user.gravatarId || md5((user.email || '').trim().toLowerCase());
            url = user.gravatarId
              ? 'https://www.gravatar.com/avatar/' +
                user.gravatarId +
                '?s=' +
                size
              : defaultImage;
            break;
          default:
            url = defaultImage;
        }
        return url;
      },

      canUsePaidFeatures(user = this.user) {
        return this.getSubscriptionType(user) !== UserSubscriptionType.Free;
      },

      /**
       * @returns {SubscriptionType}
       */
      getSubscriptionType(user = this.user) {
        if (!user) return null;

        return Boolean(user?.subscriptionType)
          ? user.subscriptionType
          : UserSubscriptionType.Free;
      },
      getPlanId(user = this.user) {
        if (!user) return null;

        const activePurchase = this.getActivePurchase();

        if (this.institution && this.institution.id) {
          const [purchase] = this.institution.purchases.filter(
            (purchase) => purchase.isActive
          );
          return purchase.planId;
        }
        if (!activePurchase) return 'Free';

        return activePurchase.planId;
      },
      getPlanType(user = this.user) {
        const planName = this.getPlanName(user);
        return planName ? planName.toLowerCase() : undefined;
      },
      getPlanName(user = this.user) {
        if (!user) return null;

        return Boolean(PlanNames[user.subscriptionType])
          ? PlanNames[user.subscriptionType]
          : '';
      },
      getUserType() {
        if (!this.user) return null;
        const institutionMember = this.user.institutionsMemberships.find(
          (membership) =>
            this.institution
              ? this.institution.id === membership.institutionId
              : null
        );
        return institutionMember ? institutionMember.role : UserType.Provider;
      },
      getServerTimeOffset() {
        if (!this.user) {
          return 0;
        }

        return this.user.serverTimeOffset || 0;
      },

      getInstitutionsMembershipsIds() {
        return Array.isArray(this.user.institutionsMemberships)
          ? this.user.institutionsMemberships.map((institution) =>
              String(institution.institutionId)
            )
          : [];
      },
    };
  }).name;
